import { AxiosInstance } from 'axios';

import { IItem } from 'src/views/Admin/Items/types';
import { insertId } from '../../insertId';
import { toResponse } from '../../genericToResponse';
import { cancellable } from '../../cancellable';

export default (api: AxiosInstance, url: string) => (id?: number) => {
  const urlWithId = id ? insertId(url, id) : url;
  return cancellable<IItem[]>(
    (cancelOptions: any) => api.get(urlWithId, cancelOptions),
    toResponse,
    'cache-items'
  );
};



// WEBPACK FOOTER //
// ./src/services/api/admin/items/get.ts